import React from 'react';
import { TypeA2 } from '@yme/assets/icons/license-types';
import { YamtIcon } from '@yme/assets/index';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { useRenditions, useWindowSize, useWishlist } from '@yme/hooks/index';
import { ProductLabel } from '@yme/molecules/product-label';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { DRIVER_LICENSE_A2 } from '@yme/utils/constants';
import { FavoriteCardButton } from '../favorite-card-button';
import { getDriverLicenseIcon } from '../filter-compare-card/helpers';
import { CardProductPriceBlock } from './CardProductPriceBlock';
import { DriverLicenseWrapperStyled, ImageWrapperStyled, LinkStyled, TitleStyled, YAMTIconStyled, } from './styled';
export function CardProduct({ cardProps }) {
    const { image, price, title, dataTestId = 'productCard', link = '', discount, isSaleLabelNeeded = true, isRightToLeft, sku, driverLicense, isYAMTIconShowed, is35KWIconShowed, embargoExternal, daysToShowNew, isLowestPriseExist = false, isNewLabelShowed, type, handleLinkClickCallback, } = cardProps;
    const { onLike, isLiked } = useWishlist();
    const { isMobileView } = useWindowSize();
    const { imageSrcWithDimension } = useRenditions({
        imageSrc: image.src,
    });
    const imageProps = {
        ...image,
        src: imageSrcWithDimension,
        fallbackSrc: image.src,
    };
    return (React.createElement(LinkStyled, { onClick: handleLinkClickCallback, to: link, "data-testid": dataTestId },
        React.createElement(FlexWrapper, { position: "relative" },
            React.createElement(DriverLicenseWrapperStyled, null,
                React.createElement(FlexWrapper, { gap: "4px", alignItems: "center" },
                    driverLicense && (React.createElement(SVGIcon, { type: getDriverLicenseIcon(driverLicense), size: ICON_SIZE.sm })),
                    is35KWIconShowed && driverLicense !== DRIVER_LICENSE_A2 && (React.createElement(SVGIcon, { type: TypeA2, size: ICON_SIZE.sm }))),
                isYAMTIconShowed && React.createElement(YAMTIconStyled, { type: YamtIcon })),
            React.createElement(ImageWrapperStyled, { ...imageProps, alt: title, dataTestId: "card" }),
            React.createElement(FavoriteCardButton, { isLiked: isLiked(sku), onLike: onLike(sku, link, type) }),
            React.createElement(ProductLabel, { isMobileView: isMobileView, isRightToLeft: isRightToLeft, 
                // Props of necessary labels
                isSaleLabelNeeded: isSaleLabelNeeded && Boolean(discount), 
                // for (New label)
                embargoExternal: embargoExternal, daysToShowNew: daysToShowNew, isNew: isNewLabelShowed })),
        React.createElement(FlexWrapper, { pt: "16px", isRightToLeft: isRightToLeft },
            React.createElement(TitleStyled, { weight: 500, color: colorCoreBlack900Base }, title)),
        React.createElement(CardProductPriceBlock, { price: price, isRightToLeft: isRightToLeft, discount: discount, isLabelFromVisible: isLowestPriseExist })));
}
CardProduct.displayName = 'CardProduct_Molecule';
